import * as echarts from 'echarts/core';
import { LineChart } from 'echarts/charts';
import {
  GridComponent,
  LegendComponent,
  TooltipComponent,
} from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';
import { useEffect, useRef } from 'react';
import { useSize } from 'ahooks';

echarts.use([
  LegendComponent,
  GridComponent,
  TooltipComponent,
  CanvasRenderer,
  LineChart,
]);

interface Props {
  data: Array<any>;
}

const BarCount: React.FC<Props> = ({ data }: Props) => {
  const chartRef = useRef<any>(null);
  const pieChart = useRef<any>(null);
  const size = useSize(document.body);

  useEffect(() => {
    const pieOption: any = {
      tooltip: {
        trigger: 'axis',
      },
      color: ['#FF4D4F', '#FAAD14'],
      legend: {
        bottom: '1%',
        left: 'center',
        icon: 'circle',
        itemHeight: 8,
        data: ['Faults', 'Alarms'],
      },
      grid: {
        containLabel: true,
      },
      xAxis: {
        type: 'category',
        data: [
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'May',
          'Jun',
          'Jul',
          'Aug',
          'Sep',
          'Oct',
          'Nov',
          'Dec',
        ],
        name: 'MONTH',
        nameLocation: 'middle',
        nameGap: 30,
        nameTextStyle: {
          color: '#999',
          fontSize: 11,
          fontWeight: 500,
          letterSpacing: 0.5,
        },
        boundaryGap: false,
        axisTick: { show: false },
        axisLine: {
          lineStyle: {
            color: '#EAEAEA',
          },
        },
        axisLabel: {
          color: '#545454b3',
        },
      },
      yAxis: {
        type: 'value',
        name: 'COUNT',
        nameLocation: 'middle',
        nameGap: 40,
        nameTextStyle: {
          color: '#999',
          fontSize: 11,
          fontWeight: 500,
          letterSpacing: 0.5,
        },
        interval: 5,
        min: 0,
        max: 35,
        splitLine: {
          lineStyle: {
            type: 'dashed',
            color: '#F0F0F0',
          },
        },
      },
      series: [
        {
          name: 'Faults',
          type: 'line',
          smooth: true,
          symbol: 'circle',
          symbolSize: 8,
          data: [18, 17, 19, 16, 15, 17, 14, 13, 12, 13, 11, 10],
          areaStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: 'rgba(255, 77, 79, 0.2)' },
              { offset: 1, color: 'rgba(255, 77, 79, 0.02)' },
            ]),
          },
        },
        {
          name: 'Alarms',
          type: 'line',
          smooth: true,
          symbol: 'circle',
          symbolSize: 8,
          data: [30, 28, 31, 26, 24, 27, 22, 20, 19, 21, 18, 16],
          areaStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: 'rgba(250, 173, 20, 0.2)' },
              { offset: 1, color: 'rgba(250, 173, 20, 0.02)' },
            ]),
          },
        },
      ],
    };
    if (!pieChart.current) {
      pieChart.current = echarts.init(
        chartRef.current as unknown as HTMLDivElement,
        undefined,
        {
          height: 400,
        },
      );
    }
    pieChart.current?.setOption(pieOption);
  }, [data]);

  useEffect(() => {
    pieChart.current?.resize();
  }, [size]);

  return <div ref={chartRef} />;
};

export default BarCount;
